import { Injectable, Injector } from '@angular/core'
import {
  CmsComponentData,
  CmsComponentsService,
  CmsInjectorService,
  ComponentWrapperDirective
} from '@spartacus/storefront'
import { defer, of } from 'rxjs'
import { CmsService } from '@spartacus/core'
import { map } from 'rxjs/operators'

declare module '@spartacus/core' {
  export interface ContentSlotComponentData {

    [key: string]: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class MbCmsInjectorService extends CmsInjectorService {

  constructor (protected cmsComponentsService: CmsComponentsService,
               protected injector: Injector,
               protected cmsService: CmsService) {
    super(cmsComponentsService, injector)
  }

  getInjector (type: string,
              uid: string,
              parentInjector?: Injector) {
    const configProviders = this.cmsComponentsService.getMapping(type)?.providers ?? []
    const { cxComponentWrapper } = parentInjector?.get(ComponentWrapperDirective) || {}
    return Injector.create({
      providers: [
        {
          provide: CmsComponentData,
          useValue: {
            uid,
            data$: this.getData(uid, type, cxComponentWrapper)
          }
        },
        ...configProviders,
      ],
      parent: parentInjector ?? this.injector,
    })
  }

  getData<T> (uid: string, type?: string, context?: object) {
    return defer(() => {
      const staticComponentData = {
        ...type && this.cmsComponentsService.getStaticData(type) || {},
        ...context
      }
      if (uid) {
        return this.cmsService.getComponentData(uid).pipe(
          map(data => ({
            ...staticComponentData,
            ...data
          }))
        )
      } else {
        return of(staticComponentData)
      }
    })
  }
}
